import clsx from "clsx";
import { motion } from "framer-motion";

import { usePrettyLogEventPage } from "@components/v2/analytics";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";

import { type Sorting } from "../types";

type Props = {
  name: string;
  onChange: (sorting: Sorting) => void;
};

export const HeaderMenu = ({ name, onChange }: Props) => {
  const prettyLogEventPage = usePrettyLogEventPage();

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <PopoverButton
            className={clsx(
              "flex justify-center items-center cursor-pointer",
              "rounded w-6 h-6 text-[0.65rem] ml-1",
              {
                "text-interstellar+2 hover:bg-cosmic-5": !open,
                "text-white bg-primary": open,
              },
            )}
          >
            <motion.i
              initial={false}
              animate={{ rotate: open ? 0 : 180 }}
              transition={{ duration: 0.2 }}
              className="fa-regular fa-sharp fa-chevron-up"
            />
          </PopoverButton>
          <PopoverPanel
            className={clsx(
              "absolute py-1 w-48 right-0 font-normal z-[9998]",
              "bg-white rounded-lg elevation-1 text-sm whitespace-normal",
            )}
          >
            <div
              className={clsx(
                "w-full text-left py-1.5 px-4 hover:bg-cosmic-4",
                "truncate cursor-pointer",
              )}
              onClick={() => {
                const value: Sorting = { column: name, order: "desc" };

                prettyLogEventPage({
                  domain: "Breakdown v2",
                  action: "onClick",
                  additionalActionInfo: "Change sorting",
                  data: {
                    newSorting: value,
                  },
                });

                onChange(value);
                close();
              }}
            >
              <i
                className={clsx(
                  "fa-regular fa-sharp fa-arrow-down text-[0.8rem]",
                  "text-primary mt-0.5 mr-1 w-4",
                )}
              />
              Sort descending
            </div>
            <div
              className={clsx(
                "w-full text-left py-1.5 px-4 hover:bg-cosmic-4 truncate",
                "cursor-pointer",
              )}
              onClick={() => {
                const value: Sorting = { column: name, order: "asc" };

                prettyLogEventPage({
                  domain: "Breakdown v2",
                  action: "onClick",
                  additionalActionInfo: "Change sorting",
                  data: {
                    newSorting: value,
                  },
                });

                onChange(value);
                close();
              }}
            >
              <i
                className={clsx(
                  "fa-regular fa-sharp fa-arrow-up text-[0.8rem]",
                  "text-primary mt-0.5 mr-1 w-4",
                )}
              />
              Sort ascending
            </div>
          </PopoverPanel>
        </>
      )}
    </Popover>
  );
};
